import type { Contact, Name } from 'store/types';

export default (name: Name | Contact): string => {
  const nameParts = [name.firstName, name.middleName, name.lastName, name.suffix]
    .map((part: string | undefined) => (part ? part.trim() : part))
    .filter((part) => !!part);
  return nameParts.join(' ');
};
